import { render, staticRenderFns } from "./BuyFatworaPrint.vue?vue&type=template&id=03908812&"
import script from "./BuyFatworaPrint.vue?vue&type=script&lang=js&"
export * from "./BuyFatworaPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports